import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> { }

const AngleLeftIcon: React.FC<Props> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
      aria-label={props.xlinkTitle || "angle left icon"}>
      {/* <title>{props.xlinkTitle || "angle left icon"}</title> */}
      <path
        d="M10.6469 14.1801L5.03283 8.50608C4.86787 8.31606 4.7998 8.13791 4.7998 7.98649C4.7998 7.83506 4.86784 7.63108 5.00487 7.49391L10.619 1.81992C10.8996 1.53506 11.3653 1.5258 11.6584 1.79858C11.9535 2.06951 11.9631 2.52215 11.6804 2.80541L6.55487 7.98649L11.706 13.1943C11.9887 13.4764 11.9791 13.9301 11.684 14.2012C11.392 14.474 10.926 14.4651 10.6469 14.1801Z"
        fill={props.fill || "currentColor" || "#A1A1AA"}
      />
    </svg>
  );
};

export default AngleLeftIcon;
